module.exports = __webpack_public_path__ + "img/psd.0cebe55f.svg";